import { TypeIconName, TypeColors } from '@bitrise/bitkit';
import { TypeCrashStatus, TypeCrashSortKey } from '@trace/types';

export const CRASH_STATUSES: TypeCrashStatus[] = ['closed', 'open'];
export const CRASH_STATUS_DEFAULT: TypeCrashStatus = 'open';
export const CRASH_SORT_KEY_DEFAULT: TypeCrashSortKey = 'lastSeen';
export const CRASH_SORT_DIRECTION_DEFAULT = 'desc';

export const CRASH_STATUS_COLOR_MAP: { [key in TypeCrashStatus]: TypeColors } = {
  closed: 'green-3',
  open: 'red-3',
};

export const CRASH_STATUS_NAME_MAP: { [key in TypeCrashStatus]: string } = {
  closed: 'Closed',
  open: 'Open',
};

export const CRASH_STATUS_ICON_MAP: { [key in TypeCrashStatus]: TypeIconName } = {
  closed: 'TestSuccess',
  open: 'TestWarning',
};
